import { FormInstance } from 'antd'

export function toNullableObject<T extends object>(obj: T) {
  return Object.values(obj).every((value) => value == null || value === '')
    ? null
    : obj
}

export const clearedErrorsForm = (form: FormInstance) => {
  return form
    .getFieldsError()
    .filter((field) => field.errors.length)
    .map((field) => ({
      name: field.name,
      errors: []
    }))
}
